import { render, staticRenderFns } from "./CBSEAnnualMarksheet.vue?vue&type=template&id=232b6754&scoped=true&"
import script from "./CBSEAnnualMarksheet.vue?vue&type=script&lang=js&"
export * from "./CBSEAnnualMarksheet.vue?vue&type=script&lang=js&"
import style0 from "./CBSEAnnualMarksheet.vue?vue&type=style&index=0&id=232b6754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232b6754",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VOverlay,VProgressCircular,VSnackbar})
